<template>
  <div class="summary-container">
    <div class="summary-title">合计</div>
    <div class="summary-item">
      <div class="summary-item-label">零售数量：</div>
      <div class="summary-item-value">{{toFixed2(data.allNum)}}</div>
    </div>
    <div class="summary-item">
      <div class="summary-item-label">零售税额：</div>
      <div class="summary-item-value">{{toFixed2(data.allTax)}}</div>
    </div>
    <div class="summary-item">
      <div class="summary-item-label">含税零售额：</div>
      <div class="summary-item-value">{{toFixed2(data.allAmount)}}</div>
    </div>
    <div class="summary-item">
      <div class="summary-item-label">不含税零售额：</div>
      <div class="summary-item-value">{{toFixed2(data.allAmountWithoutTax)}}</div>
    </div>
    <div class="summary-item">
      <div class="summary-item-label">含税成本：</div>
      <div class="summary-item-value">{{toFixed2(data.allCostAmount)}}</div>
    </div>
    <div class="summary-item">
      <div class="summary-item-label">不含税成本：</div>
      <div class="summary-item-value">{{toFixed2(data.allCostAmountWithoutTax)}}</div>
    </div>
    <div class="summary-item">
      <div class="summary-item-label">折扣金额：</div>
      <div class="summary-item-value">{{toFixed2(data.allDiscount)}}</div>
    </div>
    <div class="summary-item" v-if="showActivity">
      <div class="summary-item-label">活动收款金额：</div>
      <div class="summary-item-value">{{toFixed2(data.allActivityProceedsAmount)}}</div>
    </div>
  </div>
</template>

<script>
import utils from '../../libs/utils';
export default {
  name: 'RetailSummaryInfo',
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    showActivity: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  methods: {
    toFixed2(value) {
      return utils.toFixed(value, 2, true);
    },
  },
};
</script>

<style lang="less" scoped>
  .summary-container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 16px;
    .summary-title {
      margin-right: 16px;
    }
    .summary-item {
        display: flex;
        margin-right: 16px;
      .summary-item-value {
        min-width: 20px;
      }
    }
  }
</style>
